
import { Canvas, Text, Group, Rect, Shadow, Object as FabricObject } from "fabric";
import { CustomFabricObject, CustomGroup } from "@/types/fabric";
import { MeasurementService } from "@/services/measurement-service";

// Calculate consistent label offset for different shape types
export const calculateLabelOffset = (shapeType: string): number => {
  // Standardized offset distance across all shapes
  return 8; // Reduced from 12 to match smaller labels
};

// Creates and returns a text object with consistent styling
export const createMeasurementText = (content: string, zoom = 1): Text => {
  return MeasurementService.createMeasurementText(content, zoom);
};

// Creates a background for the text with consistent styling
export const createLabelBackground = (text: Text, zoom = 1): Rect => {
  return MeasurementService.createLabelBackground(text, zoom);
};

// Creates a complete measurement label group with text and background
export const createMeasurementLabelGroup = (
  content: string,
  x: number,
  y: number,
  angle: number = 0,
  isPermanent: boolean = false,
  zoom: number = 1
): Group => {
  return MeasurementService.createMeasurementLabel(
    content, x, y, angle, isPermanent, zoom
  );
};

// Updates text content of an existing measurement label
export const updateMeasurementText = (label: Text | Group, content: string): void => {
  MeasurementService.updateMeasurementText(label, content);
};

// Updates all measurement labels on the canvas based on zoom
export const updateAllMeasurementLabels = (canvas: Canvas, zoomFactor: number): void => {
  MeasurementService.updateAllMeasurements(canvas, zoomFactor);
};
